import renderPage from '~/util/renderPage'
import { extractTypeFromPrepend } from '~/util/prependRoute'
export async function asyncContent({ context, process }) {
    // console.log(context.route.name)
    // force index page slugs (homepage, products)
    if (context.app && context.app.i18n && context.route) {
        if (['index___en', 'index___es'].includes(context.route.name)) {
            context.params.slug =
                context.app.i18n.locale === 'es' ? 'inicio' : 'home'
        } else if (
            ['products___en', 'products___es'].includes(context.route.name)
        ) {
            context.params.slug =
                context.app.i18n.locale === 'es' ? 'productos' : 'products'
        }
    }
    // default behavior
    // if (
    //     process.static &&
    //     process.client &&
    //     context.$payloadURL &&
    //     context.route.query.fresh !== '1'
    // ) {
    //     // console.log('We are getting the static payload here')
    //     return context.$axios.$get(context.$payloadURL(context.route))
    // }
    // console.log('We are getting a dynamic payload from Sanity here')
    const type = extractTypeFromPrepend({ route: context.route })
    const results = await renderPage({
        params: context.params,
        error: context.error,
        payload: context.payload,
        store: context.store,
        query: context.query,
        type,
        lang: context.app.i18n.locale
    })
    // if (!context.payload)
    //     console.log('query params found at asyncData', context.query)
    // if (!context.payload) console.log('async results...', results.content)
    return {
        page: results.content
    }
}

export async function asyncContentMounted(theThis) {
    // console.log('asyncContentMounted was run!')
    // if (!theThis.$route.query.preview) {
    //     console.log('No preview here!')
    // } else if (theThis.$route.query.preview) {
    //     console.log('Preview might be here!')
    // }

    if (theThis.$route.query.fresh !== '1' && !theThis.$route.query.preview) {
        console.log('asyncContentMounted was run BUT we are bailing on it')
        return theThis.page // <-- use this query param to view content published before static site generation
    }
    // console.log('asyncContentMounted was run!')
    // force homepage if index
    if (theThis.$route && theThis.$route.app && theThis.$route.app.i18n) {
        if (['index___en', 'index___es'].includes(theThis.$route.name)) {
            theThis.$route.params.slug =
                theThis.$i18n.locale === 'es' ? 'inicio' : 'home'
        } else if (
            ['products___en', 'products___es'].includes(theThis.$route.name)
        ) {
            theThis.$route.params.slug =
                theThis.$i18n.locale === 'es' ? 'productos' : 'products'
        }
    }
    // default behavior
    const type = extractTypeFromPrepend({ route: theThis.$route })
    const results = await renderPage({
        params: theThis.$route.params,
        error: null,
        payload: null,
        store: theThis.$store,
        query: theThis.$route.query,
        type,
        lang: theThis.$i18n.locale
    })
    // console.log('query params at mounted:', theThis.$route.query)
    // console.log('mounted results...', results.content)
    return results.content || theThis.page
}
